const SET_DIALOG = 'SET_DIALOG';
const INITIALIZE_DIALOG = 'INITIALIZE_DIALOG';

export { SET_DIALOG, INITIALIZE_DIALOG };
